/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowNetworkingEventTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowNetworkingEvent,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Connect!",
    "Networking Event Awaits!",
    "Meet and Greet!",
  ],
  title: "Networking Event",
  description: "Organize an engaging networking event.",
  longDescription:
    "Gather your friends for a networking event! Choose a date, decide on activities to facilitate connections, and plan refreshments!",
  emoji: "🤝",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Networking Event",
          emoji: "🤝",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the networking event?",
          emoji: "📅",
          completeAction: {
            question: "Decide on activities to facilitate networking?",
            description:
              "What activities should we include to encourage networking?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we plan?",
                emoji: "🗣",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we provide for attendees?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🍹",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Build Connections!",
    outroDescription: "Your networking event plans are set! Enjoy connecting!",
  },
};
